import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { OracleServiceCloudObjectDataset } from 'app/model/dataset/oracle-service-cloud.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleServiceCloudObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class OracleServiceCloudObjectDatasetAdapter extends TabularTypeDatasetAdapter<OracleServiceCloudObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: OracleServiceCloudObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(OracleServiceCloudObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: OracleServiceCloudObjectDataset): Promise<OracleServiceCloudObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, OracleServiceCloudObjectDataset.MODEL);
    }
}
